var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPerfGraphIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 1H19V6H24V3C24 1.89543 23.1046 1 22 1ZM19 0H18H13H12H7H6H3C1.34315 0 0 1.34315 0 3V6V7V12V13V18V19V22C0 23.6569 1.34315 25 3 25H6H7H12H13H18H19H22C23.6569 25 25 23.6569 25 22V19V18V13V12V7V6V3C25 1.34315 23.6569 0 22 0H19ZM24 18V13H19V18H24ZM18 18V13H13V18H18ZM13 19H18V24H13V19ZM12 18V13H7V18H12ZM7 19H12V24H7V19ZM6 18V13H1V18H6ZM1 19H6V24H3C1.89543 24 1 23.1046 1 22V19ZM19 19H24V22C24 23.1046 23.1046 24 22 24H19V19ZM24 12H19V7H24V12ZM18 12V7H13V12H18ZM13 6H18V1H13V6ZM12 12V7H7V12H12ZM6 12V7H1V12H6ZM7 6H12V1H7V6ZM6 6H1V3C1 1.89543 1.89543 1 3 1H6V6Z",
    fill: "#C8C8C8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 19C2.75736 16.6569 5 14 5 14L9.5 17L14 10L18.5 13L24 6",
    stroke: "#E86247",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerfGraphIcon);
export default __webpack_public_path__ + "static/media/perf-graph-icon.1d9befcd03856ec793a43f709cd4bec1.svg";
export { ForwardRef as ReactComponent };